import React from 'react';
import { ProjectState } from "../../shared";
import { AbsoluteFill, useCurrentFrame } from 'remotion';
import LayerContainer from '../LayerContainer';


function AllLayers(project: ProjectState) {
    const { layers } = project;
    console.log({project})
    const frame = useCurrentFrame();
    return (
    <>
        <AbsoluteFill style={{
            backgroundColor: "black",
            color: "white",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            {layers.map((layer, i) => {
                const key = `${i}_${JSON.stringify(layer.adjustments)}`;
                const { startFrame, endFrame } = layer;
                const isVisible = frame  >= startFrame && frame  <= endFrame;
                if (!isVisible) {
                    const threshold = Math.round(project.fps / 2);
                    if (frame > endFrame + threshold) {
                        const diff = frame + threshold - project.durationInFrames;
                        if (diff <= 0) {
                            return null;
                        }
                        if (startFrame > diff) {
                            return null;
                        }
                    }
                    if (frame < startFrame - threshold) {
                        return null;
                    }
                }
                return (
                    <LayerContainer 
                        key={key} 
                        layer={layer} 
                        project={project} />
                )
            })}
        </AbsoluteFill>
    </>
    )
}

export default AllLayers;
